/**
 * Sidebar product filter search
 * @module productFilterSearch
 */

import $ from 'jquery';
import mergeOptions from 'styleguide/lib/merge-options';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import { get } from '../lib/props';
import './product-filter-count';

export const PLUGIN_NAME = 'productFilterSearch';

export const DEFAULTS = {
  zeroResultsText: get('rcProps.filter.zeroResults', 'There are 0 results. Try a new search.'),
};

const findMatches = (phraseToMatch, list) => list
  .filter(item => {
    const regex = new RegExp(phraseToMatch, 'ig');
    return item.value.match(regex);
  })
  .map(item => item.index);


const createData = ($checkboxes) => $checkboxes.toArray()
  .map((checkbox, index) => {
    $(checkbox).data('data-original-text', checkbox.value);
    return { value: checkbox.value, index };
  });

const highlightText = (phraseToMatch, text) => {
  const regex = new RegExp(phraseToMatch, 'ig');
  return text.replace(regex, (match) => `<strong>${match}</strong>`);
};

const createZeroResults = ($container, { zeroResultsText }) => {
  const $zeroResults = $(`<p class='u-hide'>${zeroResultsText}</p>`);
  $container.find('#designer-search').closest('.field').after($zeroResults);
  return $zeroResults;
};

const countVisible = ($checkboxes) => $checkboxes.filter(':visible').length;

const checkZeroResults = ($checkboxes, $zeroResults) => {
  if (countVisible($checkboxes) === 0) {
    $zeroResults.removeClass('u-hide');
  } else {
    $zeroResults.addClass('u-hide');
  }
};

/**
 * Initializes productFilterSearch
 * @param {HTMLElement} el - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
export default function productFilterSearch(container, options = {}) {
  const $container = $(container);
  const opts = mergeOptions(DEFAULTS, options, $container);
  const $checkboxes = $container.find('input[type="checkbox"]');
  const checkboxData = createData($checkboxes);
  const $searchField = $container.find('input[type="text"');
  const $zeroResults = createZeroResults($container, opts);

  $container.productFilterCount();
  // $('[aria-controls=alldesigners]').on('click', () => {
  //   $('#alldesigners').formField();
  // });
  $searchField.on('input', () => {
    const matches = findMatches($searchField.val(), checkboxData);
    $checkboxes.each((index, checkbox) => {
      const $checkbox = $(checkbox);
      const $checkboxContainer = $checkbox.closest('.accordion__height-cap');
      const $label = $checkboxContainer.find('.checkbox__label');

      // show checkbox option
      if (matches.includes(index)) {
        $checkboxContainer.removeClass('u-hide');
        if ($searchField.val() === '') {
          $label.html($checkbox.data('data-original-text'));
          $container.removeClass('hasValue');
        } else {
          $container.addClass('hasValue');
          const highlight = highlightText($searchField.val(), $checkbox.data('data-original-text'));
          $label.html(highlight);
        }

        //  hide checkbox option
      } else {
        $checkboxContainer.addClass('u-hide');
      }
    });

    checkZeroResults($checkboxes, $zeroResults);
  });
}

registerJQueryPlugin(PLUGIN_NAME, productFilterSearch);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-filter-search.js